import { jsx as _jsx } from "react/jsx-runtime";
import usePartialUpload from '../../../../hooks/usePartialUpload';
import { useDispatch, useSelector } from 'react-redux';
import { clearAdditionalInfoState, deleteSelectedFile, updateAdditionalInfoView } from '../../../../redux/additionalInfo/additionalInfo.slice';
import submitFilesAndComments from '../../../../redux/additionalInfo/submitFilesAndComments';
import { AdditionalInfoView } from '../../../../redux/additionalInfo/typings';
import { ButtonType } from '../../../../redux/ui/typings';
import { closeModal } from '../../../../redux/ui/ui.slice';
import { t } from '../../../../strings/i18n/i18n';
import { CustomModalFooter } from '../../../../ui/patterns/SlideinModal/subcomponents';
var AdditionalInfoModalFooter = function (_a) {
    var handleCloseModal = _a.handleCloseModal;
    var dispatch = useDispatch();
    var _b = useSelector(function (_a) {
        var additionalInfo = _a.additionalInfo;
        return additionalInfo;
    }), acceptedFiles = _b.acceptedFiles, userComment = _b.userComment, currentView = _b.currentView;
    var _c = usePartialUpload(), isPartialUpload = _c.isPartialUpload, hasNewFiles = _c.hasNewFiles;
    var isPrimaryButtonDisabled = useSelector(function (_a) {
        var additionalInfo = _a.additionalInfo;
        var rejectedFiles = additionalInfo.rejectedFiles, userCommentError = additionalInfo.userCommentError, view = additionalInfo.currentView;
        var isConfirmationScreen = view === AdditionalInfoView.CancelConfirmation ||
            view === AdditionalInfoView.DeleteConfirmation ||
            view === AdditionalInfoView.SubmitConfirmation;
        if (isConfirmationScreen) {
            return false;
        }
        if (!acceptedFiles.length && !rejectedFiles.length && !userComment) {
            return true;
        }
        // if there is a user comment error or rejected file, disable the primary button
        return userCommentError !== '' || rejectedFiles.length > 0;
    });
    var _d = useSelector(function (_a) {
        var view = _a.additionalInfo.currentView;
        switch (view) {
            case AdditionalInfoView.Upload:
                return {
                    primaryButtonText: t('button.next'),
                    secondaryButtonText: t('button.cancel')
                };
            case AdditionalInfoView.CancelConfirmation:
                return {
                    primaryButtonText: t('button.yesExit'),
                    secondaryButtonText: t('button.noExit')
                };
            case AdditionalInfoView.Review:
                return {
                    primaryButtonText: t('button.submit'),
                    secondaryButtonText: t('button.goBack')
                };
            case AdditionalInfoView.SubmitConfirmation:
                return {
                    primaryButtonText: t('button.close'),
                    secondaryButtonText: ''
                };
            case AdditionalInfoView.DeleteConfirmation:
                return {
                    primaryButtonText: t('button.delete'),
                    secondaryButtonText: t('button.noDelete')
                };
            default:
                throw new Error("unimplemented button text for view ".concat(view));
        }
    }), primaryButtonText = _d.primaryButtonText, secondaryButtonText = _d.secondaryButtonText;
    var _e = useSelector(function (_a) {
        var view = _a.additionalInfo.currentView;
        switch (view) {
            case AdditionalInfoView.Upload:
                return {
                    primaryDataType: 'next',
                    secondaryDataType: 'cancel'
                };
            case AdditionalInfoView.CancelConfirmation:
                return {
                    primaryDataType: 'yes exit',
                    secondaryDataType: "no, don't exit"
                };
            case AdditionalInfoView.Review:
                return {
                    primaryDataType: 'submit',
                    secondaryDataType: 'back'
                };
            case AdditionalInfoView.SubmitConfirmation:
                return {
                    primaryDataType: 'close',
                    secondaryDataType: null
                };
            case AdditionalInfoView.DeleteConfirmation:
                return {
                    primaryDataType: 'yes delete',
                    secondaryDataType: "no, don't delete"
                };
            default:
                return {
                    primaryDataType: null,
                    secondaryDataType: null
                };
        }
    }), primaryDataType = _e.primaryDataType, secondaryDataType = _e.secondaryDataType;
    var handlePrimaryButton = function () {
        switch (currentView) {
            case AdditionalInfoView.Upload:
                if (isPartialUpload && !hasNewFiles) {
                    dispatch(updateAdditionalInfoView({
                        currentView: AdditionalInfoView.SubmitConfirmation
                    }));
                    return;
                }
                dispatch(updateAdditionalInfoView({ currentView: AdditionalInfoView.Review }));
                break;
            case AdditionalInfoView.CancelConfirmation:
            case AdditionalInfoView.SubmitConfirmation:
                dispatch(clearAdditionalInfoState());
                dispatch(closeModal());
                break;
            case AdditionalInfoView.Review:
                dispatch(submitFilesAndComments());
                break;
            case AdditionalInfoView.DeleteConfirmation:
                dispatch(deleteSelectedFile());
                break;
            default:
                throw new Error("unimplemented primary button handler for view ".concat(currentView));
        }
    };
    var handleSecondaryButton = function () {
        switch (currentView) {
            case AdditionalInfoView.Upload:
                handleCloseModal();
                break;
            case AdditionalInfoView.CancelConfirmation:
            case AdditionalInfoView.Review:
            case AdditionalInfoView.DeleteConfirmation:
                dispatch(updateAdditionalInfoView({
                    currentView: AdditionalInfoView.Upload
                }));
                break;
            default:
                throw new Error("unimplemented secondary button handler for view ".concat(currentView));
        }
    };
    var shouldNotShowSecondaryButton = currentView === AdditionalInfoView.SubmitConfirmation ||
        (isPartialUpload && currentView === AdditionalInfoView.Upload);
    return (_jsx(CustomModalFooter, { dataCy: "slide-in-modal", dataPrimaryObject: "button", dataPrimaryType: primaryDataType, dataSecondaryObject: "button", dataSecondaryType: secondaryDataType, handlePrimaryButton: handlePrimaryButton, handleSecondaryButton: !shouldNotShowSecondaryButton && handleSecondaryButton, isPrimaryDisabled: isPrimaryButtonDisabled, primaryText: primaryButtonText, secondaryButtonType: ButtonType.Ghost, secondaryText: secondaryButtonText }));
};
export default AdditionalInfoModalFooter;
//# sourceMappingURL=index.js.map